import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class BlackFloor extends Floor {
	static key = "BlackFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): BlackFloor {
		const f = new BlackFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
